import ko from 'knockout';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';

export default class ViewModel {
  constructor() {
    koSchema.properties(this);

    this.adGroup = ko.observable();
  }
}
